import {getUserName} from '@/utils/misc';

import {Employment} from './EmploymentDropdown';

export const itemToString = (employment: Employment) => {
    return employment ? getUserName(employment.user, {fallbackOnEmail: true}) : '';
};
